import { post, } from '.';

export function CreateOrUpdateLlmAssessmentItemUserFeedback(llmAssessmentId, options = {}) {
	return post<any>("/app/api/llm_assessment_items/" + (llmAssessmentId || 0).toString() + "/user_feedback", options);
}

